module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "index"
  }, [_c('nav', {
    staticClass: "nav has-shadow"
  }, [_c('div', {
    staticClass: "container"
  }, [_c('div', {
    staticClass: "nav"
  }), _vm._v(" "), _c('div', {
    staticClass: "nav-right"
  }, [_c('a', {
    staticClass: "nav-item is-tab",
    on: {
      "click": _vm.logout
    }
  }, [_vm._v("Выход")])])])]), _vm._v(" "), _c('aside', {
    staticClass: "menu is-flex"
  }, [_c('ul', {
    staticClass: "menu-list"
  }, _vm._l((_vm.userMenu), function(item) {
    return _c('router-link', {
      key: item.name,
      staticClass: "nav-item is-tab",
      attrs: {
        "to": {
          name: item.name
        },
        "active-class": "is-active"
      }
    }, [_vm._v(_vm._s(item.title))])
  }), 1), _vm._v(" "), _c('div', {
    staticClass: "menu-list link"
  }, [_c('a', {
    staticClass: "nav-item",
    attrs: {
      "href": _vm.docAdminLink
    }
  }, [_vm._v("Ссылка на новую административную панель")])])]), _vm._v(" "), _c('div', {
    staticClass: "main-content"
  }, [_c('router-view')], 1)])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-943fde00"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Index.vue
// module id = 985
// module chunks = 0